/**
 * Centralized Notification Utility
 *
 * Wrapper around Sonner toast with standardized durations per type.
 * Use this instead of importing toast directly from 'sonner'.
 */

import { toast, ExternalToast } from 'sonner';

const DURATION = {
  success: 3000,
  warning: 5000,
  error: 6000,
  info: 4000,
} as const;

export const notify = {
  success: (message: string, options?: ExternalToast): string | number =>
    toast.success(message, { duration: DURATION.success, ...options }),

  error: (message: string, options?: ExternalToast): string | number =>
    toast.error(message, { duration: DURATION.error, ...options }),

  warning: (message: string, options?: ExternalToast): string | number =>
    toast.warning(message, { duration: DURATION.warning, ...options }),

  info: (message: string, options?: ExternalToast): string | number =>
    toast.info(message, { duration: DURATION.info, ...options }),
};
